import { Store } from 'vuex'
import { initialiseStores } from '@app/utils/store-accessor'

const initializer = (store: Store<any>) => initialiseStores(store)
export const plugins = [initializer]
export * from '@app/utils/store-accessor'
